import React from "react";
import "./Industries_We_Serve.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/grid";

function Industries_We_Serve() {
  const industries = [
    { id: 1, title: "Retail and E-commerce", img: "img1.png" },
    { id: 2, title: "Information Technology (IT) & BPO", img: "it.png" },
    { id: 3, title: "Agriculture and Agribusiness", img: "img2.png" },
    { id: 4, title: "Education and Skill Development", img: "edu.jpg" },
    { id: 5, title: "Textiles and Apparel", img: "img3.png" },
    { id: 6, title: "Banking, Microfinance, and Financial Services", img: "banking.png" },
    { id: 7, title: "Construction and Real Estate", img: "img4.png" },
    { id: 8, title: "Manufacturing and Small-Scale Industries", img: "manufacture.png" },
    { id: 9, title: "Transporation and Logistics", img: "card1.png" },
    { id: 10, title: "Media and Entertainment", img: "media.png" },
    { id: 11, title: "Healthcare and Pharamaceuticals", img: "health.png" },
    { id: 12, title: "Tourism and Hospitality", img: "tourism.png" },
    { id: 13, title: "Food and Beverage", img: "food.png" },
    { id: 14, title: "Peronal and HoseHold Serivce", img: "personal.png" },
  ];

  return (
    <section className="Industries_We_Serve">
      <div className="container">
        <div className="Industries_We_Serve_holder">
          <div className="row justify-content-between">
            <div className="col-lg-6 col-12 order-lg-1 order-2">
              <div className="Industries_We_Serve_content_holder">
                <div className="heading-holder">
                  <h2 className="heading">Industries We Serve</h2>
                </div>
                <div className="text-holder">
                  <p className="content-text">
                    We work across various industries, offering specialized
                    advertising solutions through digital screens, print media,
                    & digital marketing:
                  </p>
                </div>
              </div>
              <div className="Benifits-holder">
                <Swiper
                  loop={true}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  grid={{
                    rows: 2,
                  }}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    321: { slidesPerView: 2, spaceBetween: 10 },
                    485: { slidesPerView: 2, spaceBetween: 10 },
                    576: { slidesPerView: 2, spaceBetween: 30 },
                    765: { slidesPerView: 3, spaceBetween: 30 },
                    992: { slidesPerView: 2, spaceBetween: 30 },
                    1024: { slidesPerView: 3, spaceBetween: 30 },
                    1200: { slidesPerView: 4, spaceBetween: 30 },
                    1400: { slidesPerView: 4, spaceBetween: 30 },
                  }}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  modules={[Pagination, Autoplay, Grid]}
                  className="mySwiper Industries_We_Serve_swiper"
                >
                  {industries.map((industry) => (
                    <SwiperSlide key={industry.id}>
                      <div className="main-card-div">
                        <div className="card">
                          <div className="img-main-holder">
                            <div className="img-holder">
                              <img
                                src={`Assets/Images/AboutUs/Industries_We_Serve/${industry.img}`}
                                className="company-logo"
                                alt={industry.title}
                              />
                            </div>
                          </div>
                          <div className="text-holder">
                              <h3>{industry.title}</h3>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div className="col-lg-5 col-12 order-lg-2 order-1 img-div">
              <div className="Industries_We_Serve_img_holder">
                <img
                  className="Industries_We_Serve_img"
                  src={
                    process.env.PUBLIC_URL +
                    "/Assets/Images/AboutUs/Industries_We_Serve/handshake-businessmen.png"
                  }
                  alt="Industries We Serve"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Industries_We_Serve;
